import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REPORTS_FINANCE_PRODUCTS].GET_REPORTS_FINANCE_PRODUCTS]: {
		url: '/company/:companyId/reports/finance/products/',
	},
}
